import axios from "axios";
import {
  getSessionToken,
  getCsrfToken,
} from "@futures-platform/connectors/session";

const baseUrl = process.env.REACT_APP_VOTING_BASE_URL_API;
const publicURL = process.env.REACT_APP_PUBLIC_URL;
const DRUPAL_API_URL = process.env.REACT_APP_DRUPAL_API_URL;
const ssUrl = process.env.REACT_APP_SCENARIO_API_URL;
const searchUTL = process.env.REACT_APP_SEARCH_API_URL;
const votingURL = process.env.REACT_APP_VOTING_BASE_URL_API

// async function httpRequest(method, path, payload = null) {
//   console.log('`${baseUrl}/${path}`', `${baseUrl}/${path}`)
//   return axios({
//       method,
//       url: `${baseUrl}/${path}`,
//       headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${getSessionToken()}`
//       },
//       withCredentials: true,
//       data: payload || null
//   })
// }

async function httpRequest(
  urlParam,
  method,
  path,
  payload = null,
  headers = {}
) {
  return axios({
    method,
    url: `${urlParam}/${path}`,
    headers: {
      "X-CSRF-Token": getCsrfToken(),
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionToken()}`,
      ...headers,
    },
    withCredentials: true,
    data: payload || null,
  });
}

// url: `${DRUPAL_API_URL}/v1.0/${path}`,
export const votingApi = {
  translation: async (from, to, payload) => {
    return await httpRequest('https://go2.futuresplatform.com', 'POST', `translation-api/translate/${from}/${to}`, payload, {
      'Content-Type': 'text/plain',
  })
  },
  getStatus1BookmarkNews: async (entityUri) => {
    return await httpRequest(
      votingURL,
      'GET',
      `bookmark/entityUri/${entityUri}`,
    )
  },
  addBookmarkNews: async (payload) => {
    return await httpRequest(votingURL, 'POST', `bookmark`, payload)
  },
  deleteBookmarkNews: async (entityUri) => {
    return await httpRequest(votingURL, 'DELETE', `bookmark/${entityUri}`)
  },

  storeImgToDb: async (gid, imgFile) => {
    return await httpRequest(
      publicURL,
      "PUT",
      !!gid ? `file/${gid}/image` : `file/image`,
      imgFile,
      {
        "Content-Type": imgFile?.type || "application/octet-stream",
      }
    );
  },

  getScenarioSets: async (gid) => {
    return await httpRequest(ssUrl, "GET", `${gid}/scenario_set`);
  },
  searchScenarios: async (payload) => {
    return await httpRequest(searchUTL, "POST", `scenario-card`, payload);
  },

  getScenarioSet: async (gid, scenarioSetId) => {
    return await httpRequest(
      ssUrl,
      "GET",
      `${gid}/scenario_set/${scenarioSetId}?archived=true`
    );
  },
  getScenarioSetsByGroupId: async (gid) => {
    return await httpRequest(ssUrl, "GET", `${gid}/scenario_set`);
  },
  getScenarioCards: async (gid, scenarioSetId) => {
    return await httpRequest(
      publicURL,
      "GET",
      `content-service-api/doc/scenario-set/${gid}/${scenarioSetId}`
    );
  },

  getUserName: async (userId) => {
    return await httpRequest(`${DRUPAL_API_URL}`, "GET", `v1.0/user/${userId}`);
  },
  editPreferredTrans: async (userId, payload) => {
    return await httpRequest(`${DRUPAL_API_URL}`, "PATCH", `v1.0/user/${userId}`, payload);
  },
  getListLangs: async () => {
    return await httpRequest(`${DRUPAL_API_URL}`, "GET", `v1.0/languages`);
  },
  //Voting
  //get radar phenomenon vote for current user
  getVote: async (gid, radarId, pid) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "GET",
      `voting/${gid}/radar/${radarId}/phenomenon/${pid}/user`
    );
  },

  //get all radar phenomenon votes
  getVotes: async (gid, radarId, pid) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "GET",
      `voting/${gid}/radar/${radarId}/phenomenon/${pid}`
    );
  },

  //vote on radar phenomenon as current user
  addVote: async (gid, radarId, pid, payload) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "POST",
      `voting/${gid}/radar/${radarId}/phenomenon/${pid}`,
      payload
    );
  },

  // cancel radar phenomenon vote for current user
  deleteVote: async (gid, radarId, pid) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "DELETE",
      `voting/${gid}/radar/${radarId}/phenomenon/${pid}/user`
    );
  },

  //ThumbUp
  //get radar phenomenon comment vote for current user
  getLike: async (gid, rid, pid, cid) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "GET",
      `voting/${gid}/radar/${rid}/phenomenon/${pid}/comment/${cid}/user`
    );
  },
  exportPdfReport: async (payload) => {
    try {
      
      const response = await axios({
        method: 'POST',
        url: `${publicURL}/api/export-pdf`,
        headers: {
          'X-CSRF-Token': getCsrfToken(),
          'Content-Type': 'application/json',
          'Accept': 'application/pdf',
          'Authorization': `Bearer ${getSessionToken()}`,
        },
        data: payload,
        responseType: 'arraybuffer',
        withCredentials: true,
      });
      
      if (!response.data || response.data.byteLength === 0) {
        console.error('Empty PDF data received from server');
        return { 
          success: false, 
          error: 'Empty PDF data received'
        };
      }
      
      // Create a blob from the PDF data
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      
      // Create the filename with improved sanitization for international characters
      const sanitizeForFilename = (str) => {
        if (!str) return '';
        // Only replace characters invalid in filenames across operating systems
        // Preserve Unicode characters including Arabic, Chinese, etc.
        return str.replace(/[\\/:*?"<>|]/g, '_').trim();
      };
      
      const sanitizedTitle = payload.title ? sanitizeForFilename(payload.title) : '';
      const exportDate = payload.export_date || new Date().toISOString().split('T')[0];
      
      // Add current time to filename
      // const now = new Date();
      // const timeStr = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}`;
      
      const filename = sanitizedTitle ? 
        `${sanitizedTitle} FP ${exportDate}.pdf` : 
        `phenomenon-export - FP ${exportDate}.pdf`;
      
      // Create and trigger download link
      const downloadLink = document.createElement('a');
      downloadLink.style.display = 'none';
      downloadLink.href = blobUrl;
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      
      // Trigger download
      downloadLink.click();
      
      // Clean up resources
      setTimeout(() => {
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(blobUrl);
      }, 1000);
      
      return { 
        success: true, 
        downloaded: true,
        filename,
        size: response.data.byteLength
      };
    } catch (error) {
      console.error('Error exporting PDF:', error);
      return { 
        success: false, 
        error: error.message, 
        details: error.response ? {
          status: error.response.status,
          data: error.response.data
        } : null 
      };
    }
  },

  //get all radar phenomenon comment votes
  getLikes: async (gid, rid, pid, cid) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "GET",
      `voting/${gid}/radar/${rid}/phenomenon/${pid}/comment/${cid}`
    );
  },

  //vote on radar phenomenon comment as current user
  addLike: async (gid, rid, pid, cid, payload) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "POST",
      `voting/${gid}/radar/${rid}/phenomenon/${pid}/comment/${cid}`,
      payload
    );
  },

  //get all avg radar phenomenon ratings
  getPhenomenonRatings: async (gid, radarId, pid) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "GET",
      `rating/${gid}/radar/${radarId}/phenomenon/${pid}`
    );
  },

  //Rating
  //get avg radar phenomenon rating for current user
  getRatingsCurrentUser: async (gid, radarId, pid) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "GET",
      `rating/${gid}/radar/${radarId}/phenomenon/${pid}/user`
    );
  },
  //rate on radar phenomenon as current user
  addRatingCurrentUser: async (gid, radarId, pid, ratingId, payload) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "POST",
      `rating/${gid}/radar/${radarId}/phenomenon/${pid}/${ratingId}`,
      payload
    );
  },

  //clear radar phenomenon ratings for current user
  clearRatingsCurrentUser: async (gid, radarId, pid) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "DELETE",
      `rating/${gid}/radar/${radarId}/phenomenon/${pid}/user`
    );
  },

  getFlipAxisAfterSaved: async (gid, radarId) => {
    if (!gid || gid === "NaN" || gid === undefined) return null;
    return await httpRequest(
      baseUrl,
      "GET",
      `meta/rating/${gid}/radar/${radarId}/flipAxisAfterSaved/`
    );
  },
};
